import { useRouter } from "next/router";
import { EXTERNAL_PATHS } from "~/const/paths";
import { useClient } from "~/hooks/use-client";
import { uriConverter } from "~/util/uri-converter";

/**
 * ウェルカムページの URL を返す処理
 */
export const useWelcomePageUrl = () => {
  const isClient = useClient();
  const { asPath } = useRouter();
  const url = isClient ? location.href : `${process.env.NEXT_PUBLIC_FRONT_URL}${asPath}`;
  const backUrl = uriConverter.encode(url);
  const welcomePageUrl = `${EXTERNAL_PATHS.WELCOME}${backUrl}`;

  return welcomePageUrl;
};
